import styled from "styled-components";

export const WarningList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 5px 0 0 0;
`;